<div *ngIf="hasValidResults()">
  <div class="accessibility-intro mb-8" *ngIf="accessibilityData?.AxeContentCheck">
    <i (click)="accessibilityInfo.toggle($event)" class="accessibility-intro__icon pi pi-info-circle"></i>
    <h2 class="text-xl font-bold px-2 py-1">{{ getTotalIssuesCount() }}</h2>
    <p-popover #accessibilityInfo [style]="{maxWidth: '400px'}">
      The Codeable Profiler scans your WordPress site and lists all the plugins that are found in the HTML of the pages
      that were scanned.
    </p-popover>
  </div>

  <div *ngFor="let page of accessibilityData.AxeContentCheck; let i = index; trackBy: trackByIndex">
    <div *ngIf="page.status !== 'error' && page.recommendations">
      <div class="w-full mb-10">
        <div class="mb-0">
          <span class="font-bold pl-2 pr-2">URL:</span>
          <span class="">{{ page.url }}</span>
          <a href="{{page.url}}" target="_blank" rel="noopener"
             title="Link to Page" [style]="{'display':'inline-block','marginLeft': '10px', 'fontSize': '12px'}">
            <i class="pi pi-external-link" [style]="{'fontSize': '12px'}"></i>
          </a>
        </div>

        <p-table [value]="page.recommendations" [tableStyle]="{ 'min-width': '50rem' }">
          <ng-template pTemplate="header">
            <tr>
              <th class="p-1 font-bold">{{ getIssuesCountText(page.issues) }}</th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-recommendation>
            <tr>
              <td>{{ recommendation }}</td>
            </tr>
          </ng-template>
        </p-table>

        <div>
          <a href="{{getReportUrlFromPath(page.reportPath)}}" target="_blank" rel="noopener noreferrer"
             class="bg-black text-white font-bold py-1 px-2 rounded inline-block mt-2 ml-2">
            View Report
          </a>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="getPagesWithNoIssues().length > 0">
    <h3>Pages with no issues:</h3>
    <div *ngFor="let page of getPagesWithNoIssues(); let i = index; trackBy: trackByIndex">
      <div class="mb-2">
        <span>{{ page.url }}</span>
        <a href="{{page.url}}" target="_blank" rel="noopener"
           title="Link to Page" class="ml-2 text-sm">
          <i class="pi pi-external-link"></i>
        </a>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="getPagesWithErrors().length > 0">
    <h3>Pages with errors:</h3>
    <div *ngFor="let page of getPagesWithErrors(); let i = index; trackBy: trackByIndex">
      <div class="mb-2">
        <span>{{ page.error }}</span>
      </div>
    </div>
  </ng-container>
</div>

<div *ngIf="!hasValidResults()" class="p-4 text-center">
  <p class="text-gray-600">No accessibility results available at this time. Please try again later.</p>
</div>
